import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import find from 'lodash-es/find';
import { Observable, ConnectableObservable, pipe } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import { Site } from './site.model';

@Injectable()
export class SitesService {
    private sites$: ConnectableObservable<Site[]>;

    constructor(private http: HttpClient) {
        this.sites$ = this.http.get<Site[]>('sites').pipe(
            publishReplay(1),
            refCount()
        ) as ConnectableObservable<Site[]>;
    }

    all(): Observable<Site[]> {
        return this.sites$;
    }

    get(site: string): Observable<Site> {
        return this.sites$.pipe(
            map(sites => find(sites, (s: Site): boolean => s.siteNumber === site))
        );
    }
}
